'use client'
import { Button } from '@paladise/ui/components/ui/button'
import { cn } from '@paladise/ui/lib/utils'
import { PrivacyPolicy, UserTerms } from 'components/terms/Terms'
import { ROUTE_PATH } from 'config/routerPath'
import { useTranslations } from 'next-intl'
import { useRouter } from 'next/navigation'
import React from 'react'

interface Prop {
  title: string
  amount: string
  loading: boolean
  isCurrentUserPlan: boolean
  hsaIosSubscription: boolean
  isCancel?: boolean
  onClick: () => void
}

function PlanFooter({
  title,
  amount,
  loading,
  isCurrentUserPlan,
  hsaIosSubscription,
  isCancel,
  onClick,
}: Prop) {
  const { push } = useRouter()
  const t = useTranslations()
  return (
    <div className="border-t-glass-separators min768:block hidden w-full border-t py-5">
      <div className="mx-auto flex max-w-[768px] justify-between px-4">
        <div className="text-largeBody text-label-l1">
          <p> {title}</p>
          <p className="mt-6">
            <span className="-mt-2 text-[50px] font-bold">{`$${amount}`}</span>
            {t('month')}
          </p>
          <p className="my-2"> {t('plans_billed_monthly')}</p>
        </div>

        <div className="w-[480px]">
          {!hsaIosSubscription && (
            <Button
              variant="gray"
              className={cn(
                'text-button-on-primary bg-button-p1 hover:bg-button-p1-hover mb-3 w-full rounded-full',
                isCurrentUserPlan && !isCancel && 'bg-label-l3 text-label-l2',
              )}
              loadingClassName="text-button-on-primary"
              loading={loading}
              disabled={loading || (isCurrentUserPlan && !isCancel)}
              onClick={() => {
                if (isCancel) {
                  push(ROUTE_PATH.ACCOUNT.INDEX)
                  return
                }
                onClick?.()
              }}
            >
              {isCancel
                ? t('resume_plan')
                : isCurrentUserPlan
                  ? t('current_plan')
                  : t('plans_start_at', { amount })}
            </Button>
          )}
          <p className="text-caption text-label-l2">
            {t.rich('plans_purchase_description', {
              t1: () => <UserTerms />,
              t2: () => <PrivacyPolicy />,
            })}
          </p>
        </div>
      </div>
    </div>
  )
}

export default PlanFooter
